<!-- ************************new-branding-supplier-onboarding************************************ -->
<div class="content  container-fluid">
    <br>
    <div class=" static container-fluid mr-0 ml-0 pl-0">
        <img src="assets/svg/Page 1.svg" alt="">
        <div class="container-fluid progress-heading row mt-3 mr-0 ml-0">
            <div class="col-md-3 pr-0 pl-0 ">
                <h6 class="text-center step pr-5">Step 1</h6>
                <h6 class="text-center info">General Information</h6>
            </div>
            <div class="col-md-3 pl-0 pr-0 ">
                <h6 class="text-center step inactive">Step 2</h6>
                <h6 class="text-center info inactive">Capabilities</h6>
            </div>
            <div class="col-md-3 pr-0 pl-0">
                <h6 class="text-center step inactive">Step 3</h6>
                <h6 class="text-center info inactive">Terms & Conditions</h6>
            </div>
            <div class="col-md-3 pr-0 pl-0">
                <h6 class="text-center step inactive">Step 4</h6>
                <h6 class="text-center info inactive">Completed</h6>
            </div>
        </div>
    </div>
    <br>
    <br>
    <div class="head container-fluid ">
        <h6>General Information</h6>
    </div>
    <div class="body container-fluid mr-0 ml-0">
        <form [formGroup]="companyDetailsForm">
            <div class="sub-head row mr-0 ml-0">
                <div class="number">
                    <p class="mb-0 semi-bold">1</p>
                </div>
                <div class="ml-4">
                    <h6 class="mb-0">Company Profile</h6>
                </div>
            </div>
            <div class="form custom-form one-f mr-0 ml-0">
                <div class="row ml-0 mr-0">
                    <div class="col-md-6 pl-0 mb-4">
                        <label for="">Company Name</label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('company_name').value == '' && companyDetailsForm.get('company_name').touched">Company Name is required</span>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('company_name').invalid && companyDetailsForm.get('company_name').touched && companyDetailsForm.get('company_name').value != '' && companyDetailsForm.get('company_name').value.length < 3">Company Name minimum length 3.</span>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('company_name').invalid && companyDetailsForm.get('company_name').touched && companyDetailsForm.get('company_name').value != '' && companyDetailsForm.get('company_name').value.length > 3">Company Name is Invalid</span>
                        <input type="text" placeholder="eg. Atharva Pvt. Ltd." formControlName="company_name" [ngClass]="{ 'is-invalid':companyDetailsForm.get('company_name').invalid && companyDetailsForm.get('company_name').touched  }">
                    </div>
                    <div class="col-md-6 pr-0">
                        <label for="">Website</label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('website_url').invalid && companyDetailsForm.get('website_url').touched">Website is invalid</span>
                        <input type="text" placeholder="eg. www.atharva.io" formControlName="website_url" [ngClass]="{ 'is-invalid':companyDetailsForm.get('website_url').invalid && companyDetailsForm.get('website_url').touched  }">
                    </div>
                </div>
                <div class="row mr-0 ml-0">
                    <div class="col-md-6 pl-0 mb-4">
                        <div class="row mr-0 ml-0">
                            <div class="col-md-9 pl-0">
                                <label for="">Last year's Revenue(optional)</label>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').touched">Last Year Revenue is required </span>
                                <input type="text" formControlName="last_year_revenue" [ngClass]="{ 'is-invalid':companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').touched }">
                            </div>
                            <div class="dropdown mt-4 col-md-3 pr-0">
                                <span class="form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue_unit').invalid && companyDetailsForm.get('last_year_revenue_unit').touched">required</span>
                                <select class="select arrow-img mt-1" name="" id="" formControlName="last_year_revenue_unit">                                                            
                                 <option value="INR">INR</option>
                                 <option value="USD">USD</option>
                              </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 pr-0">
                        <label for="">Type of Industry/Organization </label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('industry_type').invalid && companyDetailsForm.get('industry_type').touched">Industry type required</span>
                        <div class="dropdown pr-0">
                            <select class="select arrow-img" name="" id="" formControlName="industry_type" [ngClass]="{ 'is-invalid': companyDetailsForm.get('industry_type').invalid && companyDetailsForm.get('industry_type').touched }">   
                            <option value="">Select Type</option>
                            <option *ngFor="let option of industryTypes" value="{{option}}">{{option | titlecase}}</option>                            
                          </select>
                        </div>
                    </div>
                </div>
                <div class="row mr-0 ml-0 ">
                    <div class="col-md-6 pl-0 mb-4">
                        <label for="">Company PAN Number</label>
                        <span class=" form-error-text onboarding-span" *ngIf="companyDetailsForm.get('pan_number').value == '' && companyDetailsForm.get('pan_number').touched">Pan number is required</span>
                        <span class=" form-error-text onboarding-span" *ngIf="companyDetailsForm.get('pan_number').value != '' && companyDetailsForm.get('pan_number').invalid && companyDetailsForm.get('pan_number').touched">Pan number is invalid</span>
                        <input type="text" placeholder="eg. AAFCC8360F" formControlName="pan_number" [ngClass]="{ 'is-invalid':companyDetailsForm.get('pan_number').invalid && companyDetailsForm.get('pan_number').touched }" />
                    </div>
                    <div class="col-md-6 pr-0">
                        <label for="">Company GSTIN Number</label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('gst_number').value == '' && companyDetailsForm.get('gst_number').touched">GST number is required</span>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('gst_number').value != '' && companyDetailsForm.get('gst_number').invalid && companyDetailsForm.get('gst_number').touched">GST number is invalid</span>
                        <input type="text" placeholder="eg. 7AAFCC8360F1ZM" formControlName="gst_number" [ngClass]="{ 'is-invalid': companyDetailsForm.get('gst_number').invalid && companyDetailsForm.get('gst_number').touched }">
                    </div>
                </div>
                <div class="row mr-0 ml-0">
                    <div class="col-md-6 pl-0 mb-4">
                        <label for="">Total no of Employees</label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('no_of_employees').invalid && companyDetailsForm.get('no_of_employees').touched">Number of employees is required</span>
						<div class="dropdown pr-0">
                            <select class="select arrow-img" name="" id="" formControlName="no_of_employees" [ngClass]="{ 'is-invalid':companyDetailsForm.get('no_of_employees').invalid && companyDetailsForm.get('no_of_employees').touched }">    
                              <option value="">Select type</option>     
                              <option value="{{noe.id}}" *ngFor="let noe of noOfEmployees">{{noe.name}}</option>                                                   
                          </select>
                        </div>
                    </div>
                    <div class="col-md-6 pr-0">
                        <label for="">Established in </label>
                        <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('established_in_year').invalid && companyDetailsForm.get('established_in_year').touched">Established Year is required</span>
                        <div class="dropdown pr-0">
                            <select class="select arrow-img" name="" id="" formControlName="established_in_year" [ngClass]="{ 'is-invalid':companyDetailsForm.get('established_in_year').invalid && companyDetailsForm.get('established_in_year').touched }">    
                              <option value="">Select type</option>     
                              <option class="year-light" value="{{year}}" *ngFor="let year of yearsArray">{{year}}</option>                                                   
                          </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pl-0 row mb-2  mr-0 ml-0 portfolio">
                <h6 class="portfolio pl-0">Portfolio</h6>
            </div>
            <div class="row pl-0 ml-0 mr-0">
                <h6 class="upload">Upload Your Company Portfolio</h6>
            </div>
            <div class="row mr-0 ml-0">
                <div class="bar">
                    <input id="portfolioUploader" class="input-file-type" type="file" accept=".pdf, .docs, .xls, .pptx, .jpeg, .png, .docx, .jpg" (change)="onPortFolioSelect($event)">
                </div>
            </div>
            <div class="row mr-0 ml-0 mt-2">
                <img src="assets/svg/Icon feather-info.svg" alt="">
                <p class="file-text ml-2 mb-0">Maximum file size upto 10 MB</p>
            </div>
            <div class="row mr-0 ml-0 ">
                <div class="uploaded-file row r-0 ml-0 container-fluid" *ngFor="let item of this.companyDetailsForm.get('portfolio').value; let i= index">
                  <a *ngIf="item.id" class="delete pointer mt-1 mr-2" (click)="removePortfolio(item.id)"> Delete</a>
                  <a *ngIf="!item.id" class="delete pointer mt-1 mr-2" (click)="removePortfolioUploaded(i)"> Delete</a>
                    <img class="pointer" src="assets/svg/file-green.svg" alt=""><a *ngIf="item.id" (click)="downloadPortfolio(item)" class="file-name col-md-3 pointer">{{item.name}}</a>
                    <a *ngIf="!item.id" (click)="downloadPortfolioBlob()" class="file-name pointer">{{item.name}}</a>
                </div>
            </div>
            <div class="row pl-0 mb-2 mt-2 mr-0 ml-0">
                <h6 class="question">Q. Do you have a working capital requirement?</h6>
            </div>
            <div class="row pl-4 mb-3 mr-0 ml-0">
                <mat-radio-group class="row container-fluid" formControlName="working_capital_required">
                    <mat-radio-button class="pl-3 col-md-2" [value]=true (change)="checkWorkingCapitalRequired(true)" color="warn"><span class="radio-label">Yes</span></mat-radio-button>
                    <mat-radio-button [value]=false (change)="checkWorkingCapitalRequired(false)" color="warn"><span class="radio-label">No</span></mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="showAllTurnOver">
                <div class="row form custom-form mt-3 mr-0 ml-0 ">
                    <div class="col-md-6 pl-0 mb-3">
                        <div class="row mr-0 ml-0">
                            <div class="col-md-9 pl-0">
                                <label class="label-medium" for="">Current Year Turnover*</label>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('current_year_revenue').value == '' && companyDetailsForm.get('current_year_revenue').touched">Current year revenue is required </span>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('current_year_revenue').invalid && companyDetailsForm.get('current_year_revenue').value != '' && companyDetailsForm.get('current_year_revenue').touched">Current year revenue is invalid </span>
                                <input type="text" formControlName="current_year_revenue" [ngClass]="{ 'is-invalid':companyDetailsForm.get('current_year_revenue').invalid && companyDetailsForm.get('current_year_revenue').touched }">
                            </div>
                            <div class="dropdown mt-4 col-md-3 pr-0">
                                <!-- <span class="form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue_unit').invalid && companyDetailsForm.get('last_year_revenue_unit').touched">required</span> -->
                                <select class="select arrow-img mt-1" name="current_year_revenue_unit" id="current_year_revenue_unit" formControlName="current_year_revenue_unit">
                            <option value="">Select Unit</option>                            
                            <option value="INR">INR</option>
                            <option value="USD">USD</option>
                          </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 pr-0">
                        <div class="row mr-0 ml-0">
                            <div class="col-md-9 pl-0">
                                <label class="label-medium" for="">Last Year Turnover*</label>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue').value == '' && companyDetailsForm.get('last_year_revenue').touched">* Last year revenue is required </span>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').value != '' && companyDetailsForm.get('last_year_revenue').touched">* Last year revenue is invalid </span>
                                <input type="text" formControlName="last_year_revenue" [ngClass]="{ 'is-invalid':companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').touched }">
                            </div>
                            <div class="dropdown mt-4 col-md-3 pr-0">
                                <span class="form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue_unit').invalid && companyDetailsForm.get('last_year_revenue_unit').touched">required</span>
                                <select class="select arrow-img mt-1" name="last_year_revenue_unit" id="last_year_revenue_unit" formControlName="last_year_revenue_unit">
                            <option value="">Select Unit</option>                            
                            <option value="INR">INR</option>
                            <option value="USD">USD</option>
                         </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form custom-form mt-3 mr-0 ml-0">
                    <div class="col-md-6 pl-0 mb-3">
                        <div class="row mr-0 ml-0">
                            <div class="col-md-9 pl-0">
                                <label class="label-medium" for="">Last to Last Year Turnover*</label>
                                <span class=" form-error-text" *ngIf="companyDetailsForm.get('last_to_last_year_revenue').value != '' && companyDetailsForm.get('last_to_last_year_revenue').invalid && companyDetailsForm.get('last_to_last_year_revenue').touched">* Revenue is invalid </span>
                                <input type="text" formControlName="last_to_last_year_revenue" [ngClass]="{ 'is-invalid':companyDetailsForm.get('last_to_last_year_revenue').invalid && companyDetailsForm.get('last_to_last_year_revenue').touched }">
                            </div>
                            <div class="dropdown mt-4 col-md-3 pr-0">
                                <!-- <span class="form-error-text" *ngIf="companyDetailsForm.get('last_year_revenue_unit').invalid && companyDetailsForm.get('last_year_revenue_unit').touched">required</span> -->
                                <select class="select arrow-img mt-1" name="last_to_last_year_revenue_unit" id="last_to_last_year_revenue_unit" formControlName="last_to_last_year_revenue_unit">
                              <option value="">Select Unit</option>                            
                              <option value="INR">INR</option>
                              <option value="USD">USD</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-6">

              </div> -->
                </div>
            </div>
            <div class="row pl-0 mb-2 mr-0 ml-0 mt-3">
                <h6 class="question">Q. Do you undertake Export Orders?</h6>
            </div>
            <div class="row pl-4 mb-3 mr-0 ml-0">
                <mat-radio-group class="row container-fluid" formControlName="accept_export_order">
                    <mat-radio-button class="pl-3 col-md-2" [value]=true color="warn" (change)="checkAcceptExportOrder(true)"><span class="radio-label">Yes</span></mat-radio-button>
                    <mat-radio-button [value]=false color="warn" (change)="checkAcceptExportOrder(false)"><span class="radio-label">No</span></mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="row mr-0 ml-0 pl-0 form custom-form mt-3 mb-4" *ngIf="showExportLiscense">
                <div class="col-md-6 pl-0">
                    <label for="">Import Export License No. *</label>
                    <span class=" form-error-text" *ngIf="companyDetailsForm.get('export_liscense_no').value != '' && companyDetailsForm.get('export_liscense_no').touched && companyDetailsForm.get('export_liscense_no').invalid">* Import export license number invalid </span>
                    <input type="text" formControlName="export_liscense_no">
                </div>
            </div>
            <div class="row pl-0 mb-2 mr-0 ml-0">
                <h6 class="question">Q. Can you undertake Batch Orders?</h6>
            </div>
            <div class="row pl-4 mb-3 mr-0 ml-0">
                <mat-radio-group class="row container-fluid" formControlName="accept_batch_order">
                    <mat-radio-button [value]=true class="pl-3 col-md-2" color="warn"><span class="radio-label">Yes</span></mat-radio-button>
                    <mat-radio-button [value]=false color="warn"><span class="radio-label">No</span></mat-radio-button>
                </mat-radio-group>
            </div>
            <hr class="fifty">
            <div class="sub-head row mr-0 ml-0 fifty">
                <div class="number">
                    <p class="mb-0 semi-bold">2</p>
                </div>
                <div class="ml-4 ">
                    <h6 class="mb-0">Contact Details</h6>
                </div>
            </div>
            <div class="form mt-5 custom-form">
                <div class="row mr-0 ml-0">
                    <div class="col-md-6 pl-0 mb-3">
                        <h6 class="owner-involvement">Name of Director/Partner/Proprietor</h6>
                        <div class="row mr-0 ml-0">
                            <div class="dropdown col-md-3 pl-0">
                                <label for="">Title</label>
                                <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('proprietor_title').invalid && companyDetailsForm.get('proprietor_title').touched">Required</span>
                                <select class="select arrow-img " name="proprietor_title" id="proprietor_title" formControlName="proprietor_title" [ngClass]="{ 'is-invalid': companyDetailsForm.get('proprietor_title').invalid && companyDetailsForm.get('proprietor_title').touched }">                                
                                <option *ngFor="let option of proprietorTitles" value="{{option}}">{{option | titlecase}}</option>                               
                              </select>
                            </div>
                            <div class="col-md-9 pr-0">
                                <label for="">Full Name</label>
                                <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('proprietor_first_name').invalid && companyDetailsForm.get('proprietor_first_name').touched">Name is required</span>
                                <input type="text" placeholder="Full Name" formControlName="proprietor_first_name" [ngClass]="{ 'is-invalid': companyDetailsForm.get('proprietor_first_name').invalid && companyDetailsForm.get('proprietor_title').touched  }" onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 32">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-3 pr-0">
                        <h6 class="owner-involvement">Name of Contact Person</h6>
                        <div class="row mr-0 ml-0">
                            <div class="dropdown col-md-3 pl-0">
                                <label for="">Title</label>
                                <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('contact_person_title').invalid && companyDetailsForm.get('contact_person_title').touched">Required</span>
                                <select class="select arrow-img " name="contact_person_title" id="contact_person_title" formControlName="contact_person_title" [ngClass]="{ 'is-invalid': companyDetailsForm.get('contact_person_title').invalid && companyDetailsForm.get('contact_person_title').touched }">                            
                                <option *ngFor="let option of proprietorTitles" value="{{option}}">{{option | titlecase}}</option>
                              </select>
                            </div>
                            <div class="col-md-9 pr-0">
                                <label for="">Full Name</label>
                                <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('contact_person_name').invalid && companyDetailsForm.get('contact_person_name').touched">Name is required</span>
                                <input type="text" placeholder="Full Name" formControlName="contact_person_name" [ngClass]="{ 'is-invalid': companyDetailsForm.get('contact_person_name').invalid && companyDetailsForm.get('contact_person_name').touched }">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mr-0 ml-0">
                    <div class="col-md-6 pl-0 mb-3">
                        <div class="">
                            <label>Email</label>
                            <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('proprietor_email').invalid && companyDetailsForm.get('proprietor_email').touched">Email is required </span>
                            <input type="text" placeholder="Email" formControlName="proprietor_email" [ngClass]="{ 'is-invalid':companyDetailsForm.get('proprietor_email').invalid && companyDetailsForm.get('proprietor_email').touched }" autocomplete="off">
                        </div>
                    </div>
                    <div class="col-md-6 pr-0">
                        <div>
                            <label>Email</label>
                            <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('contact_person_email').invalid && companyDetailsForm.get('contact_person_email').touched">Email is required </span>
                            <input type="text" placeholder="Email" formControlName="contact_person_email" [ngClass]="{ 'is-invalid':companyDetailsForm.get('contact_person_email').invalid && companyDetailsForm.get('contact_person_email').touched  }">
                        </div>
                    </div>
                </div>
                <div class="row  mr-0 ml-0">
                    <div class="col-md-6 pl-0">
                        <div class="row mr-0 ml-0">
                            <div class="dropdown col-md-3 pl-0">
                                <label for="">Mobile</label>
                                <ng-autocomplete class="arrow-img" (focusout)="pro_code($event.target.value)" [data]="countries" [searchKeyword]="keyword" [itemTemplate]="itemTemplate" formControlName="proprietor_phone_country_code" (selected)="proprietorCountryCode($event)">
                                </ng-autocomplete>
                                <ng-template #itemTemplate let-item>
                                    <a [innerHTML]="item"></a>
                                </ng-template>
                            </div>
                            <div class="col-md-9 pr-0">
                              <span style="height: 5px;" class="form-error-text onboarding-span mb-0">&nbsp;</span>
                                <span style="height: 5px;" class="form-error-text onboarding-span mb-0" *ngIf="companyDetailsForm.get('proprietor_phone').value == '' && companyDetailsForm.get('proprietor_phone').touched">Phone is required </span>
                                <span style="height: 5px;" class="form-error-text onboarding-span mb-0" *ngIf="companyDetailsForm.get('proprietor_phone').value != '' && companyDetailsForm.get('proprietor_phone').invalid && companyDetailsForm.get('proprietor_phone').touched">Phone is invalid </span>
                                <input class="mt-4" placeholder="mobile" type="text" formControlName="proprietor_phone" [ngClass]="{ 'is-invalid':companyDetailsForm.get('proprietor_phone').invalid && companyDetailsForm.get('proprietor_phone').touched  }">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-4 pr-0">
                        <div class="row mr-0 ml-0">
                            <div class="dropdown col-md-3 pl-0">
                                <label for="">Mobile</label>
                                <ng-autocomplete class="arrow-img" (focusout)="cp_vode($event.target.value)" [data]="countries" [searchKeyword]="keyword" [itemTemplate]="itemTemplateContact" formControlName="contact_person_country_code" (selected)="contactCountryCode($event)">
                                </ng-autocomplete>
                                <ng-template #itemTemplateContact let-item>
                                    <a [innerHTML]="item"></a>
                                </ng-template>
                            </div>
                            <div class="col-md-9 pr-0">
                              <span style="height: 5px;" class="form-error-text onboarding-span mb-0">&nbsp;</span>
                                <span style="height: 5px;" class="form-error-text onboarding-span" *ngIf="companyDetailsForm.get('contact_person_phone').value == '' && companyDetailsForm.get('contact_person_phone').touched">Phone is required </span>
                                <span style="height: 5px;" class="form-error-text onboarding-span mb-0" *ngIf="companyDetailsForm.get('contact_person_phone').value != '' && companyDetailsForm.get('contact_person_phone').invalid && companyDetailsForm.get('contact_person_phone').touched">Phone is invalid </span>
                                <input class="mt-4" type="text" placeholder="mobile" formControlName="contact_person_phone" [ngClass]="{ 'is-invalid': companyDetailsForm.get('contact_person_phone').invalid && companyDetailsForm.get('contact_person_phone').touched }">
                                <p *ngIf="!has_verified_phone" class="otp mt-2"><img src="assets/svg/Icon feather-info.svg" alt="">&nbsp;Verification OTP will be shared &nbsp;&nbsp;<span class="pointer text-right" (click)="sendOtp()">Get OTP</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="fifty">
            <div class="sub-head fifty row mt-4 mb-5 mr-0 ml-0">
                <div class="number">
                    <p class="mb-0 semi-bold">3</p>
                </div>
                <div class="ml-4">
                    <h6 class="mb-0">Address</h6>
                </div>
            </div>
            <div class="form custom-form">
                <div formArrayName="address_attributes">
                    <div *ngFor="let item of companyDetailsForm.controls.address_attributes.controls; let i = index">
                        <div [formGroupName]="i" *ngIf="isPrimaryAddress(item)">
                            <div class="row mr-0 mb-3 ml-0 mr-0">
                                <label for="">Registered Address</label>
                                <span class=" form-error-text onboarding-span col-md-10" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">*Address is Required</span>
                                <span class=" form-error-text onboarding-span col-md-10" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">*Address is invalid</span>
                                <input type="text" placeholder="Address" formControlName="address" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched}">
                            </div>
                            <div class="row mb-3 mr-0 ml-0">
                                <div class="col-md-3 pl-0">
                                    <label for="">City</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched">*City is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched">*City is invalid</span>
                                    <input type="text" placeholder="City" formControlName="city" [ngClass]="{ 'is-invalid':companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched}">
                                </div>
                                <div class="col-md-3">
                                    <label for="">State</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">*state is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">*state is invalid</span>
                                    <input type="text" placeholder="State" formControlName="state" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched}">
                                </div>
                                <div class="col-md-3">
                                    <label for="">Pincode</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required">*Pincode is required</span>
                                    <input type="text" placeholder="Pincode" formControlName="pin_code" minLength="6" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required }">
                                </div>
                                <div class="dropdown col-md-3 pr-0">
                                    <label for="">Country</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">*Country is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">*Country is invalid</span>
                                    <input class="" formControlName="country" name="" id="" placeholder="Country" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched }">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <hr>
                <br>
                <div formArrayName="address_attributes">
                    <div *ngFor="let item of companyDetailsForm.controls.address_attributes.controls; let i = index">
                        <div [formGroupName]="i" *ngIf="!isPrimaryAddress(item)">
                            <div class="row mr-0 mb-3 ml-0">
                                <label for="">Factory Address</label>
                                <span class="form-error-text onboarding-span col-md-10" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">Address is required</span>
                                <span class="form-error-text onboarding-span col-md-10" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">Address is invalid</span>
                                <input type="text" name="address" placeholder="Address" formControlName="address" [ngClass]="{ 'is-invalid':companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched }">
                            </div>
                            <div class="row mb-4 mr-0 ml-0">
                                <div class="col-md-3 pl-0">
                                    <label for="">City</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched"> *City is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched"> *City is invalid</span>
                                    <input type="text" placeholder="City" formControlName="city" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched}">
                                </div>
                                <div class="col-md-3">
                                    <label for="">State</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">*State is Required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">*State is invalid</span>
                                    <input type="text" placeholder="State" formControlName="state" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched }">
                                </div>
                                <div class="col-md-3">
                                    <label for="">Pincode</label>
                                    <span class="form-error-text onboarding-span" *ngIf="submitted && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required">*Pincode is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="submitted && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.pattern">*Pincode is invalid</span>
                                    <input type="text" placeholder="Pincode" formControlName="pin_code" [ngClass]="{ 'is-invalid': submitted && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required }">
                                </div>
                                <div class="dropdown col-md-3 pr-0">
                                    <label for="">Country</label>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').value == '' && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">*Country is required</span>
                                    <span class="form-error-text onboarding-span" *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').value != '' && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">*Country is invalid</span>
                                    <input class=" " name="country" placeholder="Country" id="country" formControlName="country" [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched}">
                                </div>
                            </div>
                            <div class="form custom-form mr-0 ml-0  mb-3 mt-3 container-fluid pl-0" *ngIf="!isPrimaryAddress(item)">
                                <h6 class="factory-space mt-4"> Q.Factory Space is Leased or Own?</h6>
                                <div>
                                    <mat-radio-group class="row container-fluid" formControlName="property_type">
                                        <div class="col-md-2">
                                            <mat-radio-button value="owned" color="warn" id="{{ 'owned' + i}}"><span class="radio-label">Owned</span></mat-radio-button>
                                        </div>
                                        <div class="col-md-2">
                                            <mat-radio-button value="leased" color="warn" id="{{ 'leased' + i}}"><span class="radio-label">Leased</span></mat-radio-button>
                                        </div>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <button type="button" class="green-button" (click)="removeFactoryAddress(i)" *ngIf="i != 0">Remove this address</button>
                        </div>
                    </div>
                </div>
                <br>
                <!-- <div class=" row container-fluid pl-0 mb-4">
                  <button type="button" class="green-button" (click)="removeFactoryAddress(i)" *ngIf="i != 0">Remove this address</button>
              </div> -->
                <div class=" row container-fluid pl-0 mb-4 mr-0 ml-0">
                    <button (click)="addFactoryAddress()" class="green-button">Add Factory Address</button>

                </div>

            </div>
            <hr class="fifty">
            <div class="sub-head fifty row mt-5 mb-4 mr-0 ml-0">
                <div class="number">
                    <p class="mb-0 semi-bold">4</p>
                </div>
                <div class="ml-4">
                    <h6 class="mb-0">Additional Information</h6>
                </div>
            </div>
            <div class="form custom-form mb-5">
                <h6 class="owner-involvement mb-3">Q. Involvement of the owner in day-to-day business activities?</h6>
                <div>
                    <mat-radio-group formControlName="owner_involvement">
                        <mat-radio-button color="warn" value="0%"><span class="radio-label">0%</span></mat-radio-button><br>
                        <mat-radio-button color="warn" value="upto 50%"><span class="radio-label">Upto 50%</span></mat-radio-button><br>
                        <mat-radio-button color="warn" value="100%"><span class="radio-label">100%</span></mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <br>
            <hr class="">
            <br>
            <div class=" button  row  mr-0 ml-0">
                <button class="white mr-3" (click)="saveCompanyDraft()">Save Draft</button>
                <button class="primary ml-3" (click)=" submitCompanyDetails()">Continue</button>
            </div>
        </form>
    </div>
</div>


<!-- <div class="comtainer-fluid nav-data">
  <div class="container">
    <ul class="nav nav-tabs tabs">
      <li><a data-toggle="tab" routerLink="/onboarding" class="active">General Information</a></li>
      <li><a data-toggle="tab" routerLink="/onboarding/machine-details">Capabilities</a></li>
      <li><a data-toggle="tab" routerLink="/onboarding/terms">Terms and Conditions</a></li>
    </ul>
  </div>
</div>
<div class="container no-padding">
  <div class="col-md-12 set-manuf-patrner display-flex-lg">
    <div class="col-md-4 manf-text no-padding">
      <h1>Setup Manufacturing Partner Account </h1>
      <p>Let's help you get started setting up MP Account. Here are Some key things to do</p>
    </div>
    <div class="col-md-3 offset-md-1 pages-link">
      <nav class="">
        <a routerLink="/onboarding" class="active"><span>Step 1</span> Company Details</a>
        &nbsp;&nbsp;&nbsp;
        <a routerLink="/onboarding/machine-details"><span>Step 2</span> Machine Details</a>
        &nbsp;&nbsp;&nbsp;
        <a routerLink="/onboarding/terms"><span>Step 3</span> Terms and Conditions</a>
        &nbsp;&nbsp;&nbsp;
      </nav>
    </div>
  </div>

  <div class="company-profile-block top-margin">
    <div class="col-md-12 no-padding">
      <h4>Company Profile</h4>
    </div>
    <form [formGroup]="companyDetailsForm" (ngSubmit)="submitCompanyDetails()">
      <div class="col-md-12 blue-box-container">
        <div class="col-md-10">
          <div class="col-md-12 no-padding">
            <div class="form-group">
              <label class="blue-color-heading">Company Name *</label>
              <input type="text" name="company_name" class="form-control" formControlName="company_name"
                [ngClass]="{ 'is-invalid':companyDetailsForm.get('company_name').invalid && companyDetailsForm.get('company_name').touched  }">
              <span class=""
                *ngIf="companyDetailsForm.get('company_name').invalid && companyDetailsForm.get('company_name').touched">
                <div class="form-error" *ngIf="companyDetailsForm.get('company_name').errors?.required">Company Name is
                  required</div>
              </span>
            </div>
          </div>
          <div class="col-md-12 col-12 no-padding display-flex-lg">
            <div class="col-md-5 col-12 no-padding">
              <div class="form-group ">
                <label class="blue-color-heading">Website</label>
                <input type="text" name="website_url" class="form-control" formControlName="website_url">
              </div>
            </div>
            <div class="col-md-5 col-12 offset-md-2 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Established in *</label>
                <input type="number" name="established_in_year" class="form-control"
                  formControlName="established_in_year"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('established_in_year').invalid && companyDetailsForm.get('established_in_year').touched }" />
                <span class=""
                  *ngIf="companyDetailsForm.get('established_in_year').invalid && companyDetailsForm.get('established_in_year').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('established_in_year').errors?.required">
                    Established year is required</div>

                </span>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding display-flex-lg">
            <div class="col-md-5 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Type of Industry/Organization *</label>
                <select name="industry_type" class="form-control" formControlName="industry_type"
                  [ngClass]="{ 'is-invalid': companyDetailsForm.get('industry_type').invalid && companyDetailsForm.get('industry_type').touched }">
                  <option value="private ltd">Private Ltd</option>
                  <option value="public ltd">Public Ltd</option>
                  <option value="llp">LLP/Partnership</option>
                  <option value="partnership">Partnership</option>
                  <option value="proprietorship">Proprietorship</option>
                  <option value="huf">HUF</option>
                  <option value="other">Other</option>
                </select>
                <span class=""
                  *ngIf="companyDetailsForm.get('industry_type').invalid && companyDetailsForm.get('industry_type').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('industry_type').errors?.required">
                    Industry/Organization is required</div>
                </span>
              </div>
            </div>
            <div class="col-md-5 offset-md-2 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Total no of Employees</label>
                <input type="number" name="no_of_employees" class="form-control" formControlName="no_of_employees"
                  min="1" max="1000000">
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding display-flex-lg">
            <div class="col-md-5 no-padding">
              <div class="form-group ">
                <label class="blue-color-heading">Company GSTIN Number *</label>
                <input type="text" name="gst_number" class="form-control" formControlName="gst_number"
                  [ngClass]="{ 'is-invalid': companyDetailsForm.get('gst_number').invalid && companyDetailsForm.get('gst_number').touched }">
                <span class=""
                  *ngIf="companyDetailsForm.get('gst_number').invalid && companyDetailsForm.get('gst_number').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('gst_number').errors?.required">Company GSTIN
                    Number is required</div>
                </span>
              </div>
            </div>
            <div class="col-md-5 offset-md-2 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Company Pan Number *</label>
                <input type="text" name="pan_number" class="form-control" formControlName="pan_number"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('pan_number').invalid && companyDetailsForm.get('pan_number').touched }" />
                <span class=""
                  *ngIf="companyDetailsForm.get('pan_number').invalid && companyDetailsForm.get('pan_number').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('pan_number').errors?.required">Company Pan
                    Number is required</div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding display-flex-lg">
            <div class="col-md-4 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Last Year's Revenue</label>
                <div class="display-flex-lg col-sm-12 no-padding">
                  <div class="col-sm-8 no-padding-left">
                    <input type="number" name="last_year_revenue" class="form-control" formControlName="last_year_revenue"
                      min="1" max="1000000">
                  </div>
                  <select name="last_year_revenue_unit" class="form-control col-sm-4" formControlName="last_year_revenue_unit" style="height:40px;">
                    <option value="INR">INR</option>
                    <option value="USD">USD</option>
                  </select>
                </div>               
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <h3 class="top-margin-sm blue-color-heading">Do you have a working capital requirement?*</h3>
            <div class="form-group">
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="working_capital_required"
                    formControlName="working_capital_required" [value]="true"
                    (change)="checkWorkingCapitalRequired(true)">Yes
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="working_capital_required"
                    formControlName="working_capital_required" [value]="false"
                    (change)="checkWorkingCapitalRequired(false)">No
                </label>
              </div>
              <span class=""
                *ngIf="companyDetailsForm.get('working_capital_required').invalid && companyDetailsForm.get('working_capital_required').touched">
                <div class="form-error" *ngIf="companyDetailsForm.get('working_capital_required').errors?.required">This
                  Feild is required</div>
              </span>
            </div>
          </div>
          <div class="col-md-12 no-padding display-flex-lg" *ngIf="showAllTurnOver">
            <div class="col-md-4 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Current Year TurnOver</label>
                <div class="display-flex-lg col-sm-12 no-padding">
                  <div class="col-sm-8 no-padding-left">
                    <input type="number" name="current_year_revenue" class="form-control"
                      formControlName="current_year_revenue"
                      [ngClass]="{ 'is-invalid':companyDetailsForm.get('current_year_revenue').invalid && companyDetailsForm.get('current_year_revenue').touched }">
                    <span class=""
                      *ngIf="companyDetailsForm.get('current_year_revenue').invalid && companyDetailsForm.get('current_year_revenue').touched">
                      <div class="form-error" *ngIf="companyDetailsForm.get('current_year_revenue').errors?.required">
                        Current Year TurnOver is required</div>
                    </span>
                  </div>

                  <select name="current_year_revenue_unit" class="form-control col-md-4"
                    formControlName="current_year_revenue_unit" style="height:40px;">
                    <option value="INR">INR</option>
                    <option value="USD">USD</option>
                  </select>

                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="blue-color-heading">Last Year TurnOver</label>
                <div class="display-flex-lg col-sm-12 no-padding">
                  <div class="col-sm-8 no-padding-left">
                <input type="number" name="last_year_revenue" class="form-control" formControlName="last_year_revenue"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').touched }">
                <span class=""
                  *ngIf="companyDetailsForm.get('last_year_revenue').invalid && companyDetailsForm.get('last_year_revenue').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('last_year_revenue').errors?.required">Last Year
                    TurnOver is required</div>
                </span>
                </div>
                <select name="last_year_revenue_unit" class="form-control col-md-4" formControlName="last_year_revenue_unit" style="height:40px;">
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                </select>
                </div>
              </div>
            </div>
            <div class="col-md-4 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Last to Last Year TurnOver</label>
                <div class="display-flex-lg col-sm-12 no-padding">
                  <div class="col-sm-8 no-padding-left">
                <input type="number" name="last_to_last_year_revenue" class="form-control"
                  formControlName="last_to_last_year_revenue"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('last_to_last_year_revenue').invalid && companyDetailsForm.get('last_to_last_year_revenue').touched }">
                <span class=""
                  *ngIf="companyDetailsForm.get('last_to_last_year_revenue').invalid && companyDetailsForm.get('last_to_last_year_revenue').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('last_to_last_year_revenue').errors?.required">
                    Last to Last Year TurnOver is required</div>
                </span>
                </div>
               
                <select name="last_to_last_year_revenue_unit" class="form-control col-md-4"
                  formControlName="last_to_last_year_revenue_unit" style="height:40px;">
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                </select>
              </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <h3 class="top-margin-sm blue-color-heading">Do you undertake Export Orders?*</h3>
            <div class="form-group">
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="accept_export_order"
                    formControlName="accept_export_order" [value]="true" (change)="checkAcceptExportOrder(true)">Yes
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="accept_export_order"
                    formControlName="accept_export_order" [value]="false" (change)="checkAcceptExportOrder(false)">No
                </label>
              </div>
              <div *ngIf="submitted && f.accept_export_order.errors" class="invalid-feedback">
                <div *ngIf="f.accept_export_order.errors.required">required</div>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding" *ngIf="showExportLiscense">
            <div class="col-md-4 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Import Export License No. *</label>
                <input type="text" name="export_liscense_no auto-height" class="form-control"
                  formControlName="export_liscense_no">
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <h3 class="top-margin-sm blue-color-heading">Can you undertake Batch Orders?*</h3>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input auto-height" name="accept_batch_order"
                  formControlName="accept_batch_order" [value]="true">Yes
              </label>
            </div>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input auto-height" name="accept_batch_order"
                  formControlName="accept_batch_order" [value]="false">No
              </label>
            </div>
          </div>

          <div class="capabilities-info top-margin col-sm-12 no-padding">
            <div *ngIf="portfolioList && portfolioList.length != 0">
              <p *ngFor="let portfolio_file of portfolioList;" class="overflow-auto">
                {{portfolio_file.attachment_file.url}}
                <button type="button" class="btn btn-sm btn-danger" (click)="removePortfolio(portfolio_file.id)">
                  Delete</button>
              </p>
            </div>
            <div class="form-row top-margin-sm">
              <div class="col">
                <h4 class="heading-data">Portfolio</h4>
                <h2 class="blue-color-heading">Please upload the company portfolio, presentation, catalogue</h2>
                <input type="file" multiple name="portfolio" (change)="onPortFolioSelect($event)">
              </div>
            </div>
          </div>

          <h4 class="heading-data top-margin-sm">Contact Details</h4>
          <h3 class=" blue-color-heading">Name of Director/Partner/Proprietor *</h3>
          <div class="col-md-12 no-padding display-flex-lg">

            <div class="col-md-2 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Title</label>
                <select name="proprietor_title" class="form-control" formControlName="proprietor_title"
                  [ngClass]="{ 'is-invalid': companyDetailsForm.get('proprietor_title').invalid && companyDetailsForm.get('proprietor_title').touched }">
                  <option value="mr">Mr</option>
                  <option value="miss">Ms</option>
                  <option value="mrs">Mrs</option>
                </select>
                <span class=""
                  *ngIf="companyDetailsForm.get('proprietor_title').invalid && companyDetailsForm.get('proprietor_title').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('proprietor_title').errors?.required">Title is
                    required</div>
                </span>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label class="blue-color-heading">First Name</label>
                <input type="text" name="proprietor_first_name" class="form-control"
                  formControlName="proprietor_first_name"
                  [ngClass]="{ 'is-invalid': companyDetailsForm.get('proprietor_first_name').invalid && companyDetailsForm.get('proprietor_title').touched  }"
                  onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 32">
                <span class=""
                  *ngIf="companyDetailsForm.get('proprietor_first_name').invalid && companyDetailsForm.get('proprietor_first_name').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('proprietor_first_name').errors?.required">First
                    Name is required</div>
                </span>
              </div>
            </div>

            <div class="col-md-5 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Last Name</label>
                <input type="text" name="proprietor_last_name" class="form-control"
                  formControlName="proprietor_last_name"
                  [ngClass]="{ 'is-invalid': companyDetailsForm.get('proprietor_first_name').invalid && companyDetailsForm.get('proprietor_title').touched }"
                  onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 32">
                <span class=""
                  *ngIf="companyDetailsForm.get('proprietor_last_name').invalid && companyDetailsForm.get('proprietor_last_name').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('proprietor_last_name').errors?.required">Last
                    Name is required</div>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-12 no-padding">
            <div class="col-md-5 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Email *</label>
                <input type="text" name="proprietor_email" class="form-control" formControlName="proprietor_email"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('proprietor_email').invalid && companyDetailsForm.get('proprietor_email').touched }">
                <span class=""
                  *ngIf="companyDetailsForm.get('proprietor_email').invalid && companyDetailsForm.get('proprietor_email').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('proprietor_email').errors?.required">Email is
                    required</div>
                </span>
              </div>
            </div>
          </div>
          <h3 class="top-margin-sm blue-color-heading">Name of Contact Person *</h3>
          <div class="col-md-12 no-padding">
            <div class="form-group">
              <label class="blue-color-heading">Name</label>
              <input type="text" name="contact_person_name" class="form-control" formControlName="contact_person_name"
                [ngClass]="{ 'is-invalid': companyDetailsForm.get('contact_person_name').invalid && companyDetailsForm.get('contact_person_name').touched }"
                onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 || event.charCode == 32)">
              <span class=""
                *ngIf="companyDetailsForm.get('contact_person_name').invalid && companyDetailsForm.get('contact_person_name').touched">
                <div class="form-error" *ngIf="companyDetailsForm.get('contact_person_name').errors?.required">Name is
                  required</div>
              </span>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <div class="col-md-5 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Email *</label>
                <input readonly type="text" name="contact_person_email" class="form-control"
                  formControlName="contact_person_email"
                  [ngClass]="{ 'is-invalid':companyDetailsForm.get('contact_person_name').invalid && companyDetailsForm.get('contact_person_email').touched  }">
                <span class=""
                  *ngIf="companyDetailsForm.get('contact_person_email').invalid && companyDetailsForm.get('contact_person_email').touched">
                  <div class="form-error" *ngIf="companyDetailsForm.get('contact_person_email').errors?.required">Email
                    is required</div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <div class="col-md-5 no-padding">
              <div class="form-group">
                <label class="blue-color-heading">Phone number *</label>
                <div class="col-md-12  display-flex-lg display-flex-xs no-padding">
                  <div class="col-md-2 col-3 no-padding">
                    <input type="number" name="phone_country_code" class="form-control"
                      formControlName="phone_country_code" (input)="matchPhoneNumber()"
                      [ngClass]="{ 'is-invalid': companyDetailsForm.get('phone_country_code').invalid && companyDetailsForm.get('phone_country_code').touched}">
                    <span class=""
                      *ngIf="companyDetailsForm.get('phone_country_code').invalid && companyDetailsForm.get('phone_country_code').touched">
                      <div class="form-error" *ngIf="companyDetailsForm.get('phone_country_code').errors?.required">This
                        Feild is
                        required</div>
                      <div *ngIf="companyDetailsForm.get('phone_country_code').errors?.min" class="form-error">Must be
                        valid.</div>
                      <div *ngIf="companyDetailsForm.get('phone_country_code').errors?.max" class="form-error">Must be
                        valid.</div>
                    </span>
                  </div>
                  <div class="col-md-10 col-8 no-padding">
                    <input type="number" name="contact_person_phone" class="form-control"
                      formControlName="contact_person_phone" (input)="matchPhoneNumber()"
                      [ngClass]="{ 'is-invalid': companyDetailsForm.get('contact_person_phone').invalid && companyDetailsForm.get('contact_person_phone').touched }">
                    <span class=""
                      *ngIf="companyDetailsForm.get('contact_person_phone').invalid && companyDetailsForm.get('contact_person_phone').touched">
                      <div class="form-error" *ngIf="companyDetailsForm.get('contact_person_phone').errors?.required">
                        Phone number is
                        required</div>
                    </span>
                  </div>
                </div>
              </div>
              <button class="btn btn-warning btn-sm" (click)="sendOtp()" data-toggle="modal"
                data-target="#mobileVerificationModal" *ngIf='showSendOtpBtn'>Click to verify this number</button>
            </div>
          </div>
          <div class="group-gap top-margin" formArrayName="address_attributes">
            <div *ngFor="let item of companyDetailsForm.controls.address_attributes.controls; let i = index">
              <div class="form-row" [formGroupName]="i" *ngIf="isPrimaryAddress(item)">
                <div class="col-md-12 no-padding">
                  <h4 class="heading-data ">Address</h4>
                  <div class="form-group">


                    <label class="blue-color-heading">Registered Address*</label>
                    <input type="text" name="address" class="form-control" formControlName="address"
                      [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched}">
                    <span class=""
                      *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">
                      <div class="form-error"
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').errors?.required">
                        Address is
                        required</div>
                    </span>

                  </div>
                </div>
                <div class="col-md-12 no-padding display-flex-lg">
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">City*</label>
                      <input type="text" name="city" class="form-control" formControlName="city"
                        [ngClass]="{ 'is-invalid':companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched}">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').errors?.required">
                          City is
                          required</div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 ">
                    <div class="form-group">
                      <label class="blue-color-heading">State*</label>
                      <input type="text" name="state" class="form-control" formControlName="state"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched}">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').errors?.required">
                          State is
                          required</div>
                      </span>

                    </div>
                  </div>
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">Country*</label>
                      <input type="text" name="country" class="form-control" formControlName="country"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched }">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').errors?.required">
                          country is
                          required</div>
                      </span>

                    </div>
                  </div>
                </div>
                <div class="col-md-12 no-padding">
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">Zip code*</label>
                      <input type="text" name="pin_code" class="form-control" formControlName="pin_code" minLength="6"
                        min="9999" max="999999"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required }">
                      <div
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required"
                        class="form-error">Zip code is required.</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>


          <div class="group-gap top-margin" formArrayName="address_attributes">
            <div *ngFor="let item of companyDetailsForm.controls.address_attributes.controls; let i = index">
              <div class="form-row" [formGroupName]="i" *ngIf="!isPrimaryAddress(item)">
                <div class="col-md-12 no-padding">
                  <div class="form-group">
                    <label class="blue-color-heading">Factory Address *</label>
                    <input type="text" name="address" class="form-control" formControlName="address"
                      [ngClass]="{ 'is-invalid':companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched }">
                    <span class=""
                      *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('address').touched">
                      <div class="form-error"
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('address').errors?.required">
                        Address is
                        required</div>
                    </span>


                  </div>
                </div>
                <div class="col-md-12 no-padding display-flex-lg">
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">City*</label>
                      <input type="text" name="city" class="form-control" formControlName="city"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched}">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('city').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('city').errors?.required">
                          City is
                          required</div>
                      </span>

                    </div>
                  </div>
                  <div class="col-md-4 ">
                    <div class="form-group">
                      <label class="blue-color-heading">State*</label>
                      <input type="text" name="state" class="form-control" formControlName="state"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched }">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('state').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('state').errors?.required">
                          State is
                          required</div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">Country*</label>
                      <input type="text" name="country" class="form-control" formControlName="country"
                        [ngClass]="{ 'is-invalid': companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched}">
                      <span class=""
                        *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').invalid && companyDetailsForm.controls.address_attributes.controls[i].get('country').touched">
                        <div class="form-error"
                          *ngIf="companyDetailsForm.controls.address_attributes.controls[i].get('country').errors?.required">
                          country is
                          required</div>
                      </span>

                    </div>
                  </div>
                </div>
                <div class="col-md-12 no-padding">
                  <div class="col-md-4 no-padding">
                    <div class="form-group">
                      <label class="blue-color-heading">Zip code*</label>
                      <input type="text" name="pin_code" class="form-control" formControlName="pin_code"
                        [ngClass]="{ 'is-invalid': submitted && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required }">
                      <div
                        *ngIf="submitted && companyDetailsForm.controls.address_attributes.controls[i].get('pin_code').errors?.required"
                        class="invalid-feedback">Zip code is required.</div>

                    </div>
                  </div>
                </div>
                <div class="col-md-12 no-padding" *ngIf="!isPrimaryAddress(item)">
                  <h3 class="top-margin-sm blue-color-heading">Factory Space is Leased or Own?*</h3>
                  <p>{{item.property_type}}</p>
                  <div class="form-check-inline">
                    <label class="form-check-label" for="{{ 'owned' + i}}">
                      <input type="radio" class="form-check-input auto-height" id="{{ 'owned' + i}}"
                        formControlName="property_type" value="owned">Owned
                    </label>
                  </div>
                  <div class="form-check-inline">
                    <label class="form-check-label" for="{{ 'leased' + i}}">
                      <input type="radio" class="form-check-input auto-height" id="{{ 'leased' + i}}"
                        formControlName="property_type" value="leased">Leased
                    </label>
                  </div>
                </div>
                <button type="button" class="btn btn-primary btn-sm" (click)="removeFactoryAddress(i)"
                  *ngIf="i != 0">Remove this address</button>
                <br>
              </div>
            </div>
            <br>
            <button type="button" class="btn btn-primary btn-sm" (click)="addFactoryAddress()">Add More Factory
              Address</button>
          </div> -->


<!--<div formGroupName="factory_address">-->
<!-- <div class="col-md-12 no-padding">-->
<!--    <div class="form-group">-->
<!--      <label class="blue-color-heading">Factory Address</label>-->
<!--      <input type="text" name="address" class="form-control" placeholder="Address" formControlName="address">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="col-md-12 no-padding display-flex-lg">-->
<!--    <div class="col-md-4 no-padding">-->
<!--      <div class="form-group">-->
<!--         <label class="blue-color-heading">City</label>-->
<!--        <input type="text" name="city" class="form-control" placeholder="City" formControlName="city">-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-md-4 ">-->
<!--      <div class="form-group">-->
<!--         <label class="blue-color-heading">State</label>-->
<!--        <input type="text" name="state" class="form-control" placeholder="State" formControlName="state">-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-md-4 no-padding">-->
<!--      <div class="form-group">-->
<!--         <label class="blue-color-heading">Country</label>-->
<!--        <input type="text" name="country" class="form-control" placeholder="Country" formControlName="country">-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="col-md-12 no-padding">-->
<!--    <div class="col-md-4 no-padding">-->
<!--    <div class="form-group">-->
<!--      <label class="blue-color-heading">Zip code</label>-->
<!--      <input type="text" name="pin_code" class="form-control" placeholder="Zip Code" formControlName="pin_code">-->
<!--    </div>-->
<!--    </div>-->
<!--    </div>-->
<!--  </div>-->

<!-- </div>
        <div class="col-md-10 top-margin">
          <div class="form-group">
            <label class="blue-color-heading">Involvement of the owner/partner in day-to-day business activities ?
              *</label>
            <select name="owner_involvement" class="form-control" formControlName="owner_involvement"
              [ngClass]="{ 'is-invalid': submitted && f.owner_involvement.errors }">
              <option value="0%">0%</option>
              <option value="upto 50%">upto 50%</option>
              <option value="100%">100%</option>
            </select>
            <div *ngIf="submitted && f.owner_involvement.errors && f.owner_involvement.errors.required"
              class="invalid-feedback">is required</div>
          </div>
        </div>
      </div> -->



<!--<div class="machine-details blue-box-container ">-->
<!--  <div class="col-md-10">-->

<!--  </div>-->
<!--</div>-->
<!-- <div class="center top-margin-sm bottom-margin">
    <button name="submit" [disabled]="companyDetailsForm.invalid" class="btn btn-primary">Save And Continue</button>
</div>


</form>
</div>
</div> -->

<!-- <div class="modal" id="mobileVerificationModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content"> -->
<!-- Modal body -->
<!-- <div class="modal-body">
        <form [formGroup]="verifyMobileForm" *ngIf="!isMobileVerified">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="otp">Enter OTP</label>
            <input type="text" name="otp" class="form-control" formControlName="otp">
            <span (click)='sendOtp()' class="resend-otp"><small><i>Didn't receive? click to resend
                  OTP.</i></small></span>
          </div>
          <button class="btn btn-light btn-block" (click)='submitOtp()'>Submit</button>
        </form>
        <div *ngIf="isMobileVerified">
          <button class="close" data-dismiss="modal">&times;</button>
          <p>Successfully verified your mobile!</p>
        </div>
      </div>
    </div>
  </div>
</div> -->